import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-dyoga',
  templateUrl: './program-dyoga.component.html',
  styleUrls: ['./program-dyoga.component.scss']
})
export class ProgramDyogaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
